import styled from "styled-components";
import { responsive } from "../../styles/constants.style";

export const MdmCreateOfficeWrapper = styled.div`
  .accordion-header {
    padding: 0px 0 30px 0px;
    ${responsive.MOBILE`
      padding: 0 0px 16px 0px;
    `}
  }

  .container-office-details,
  .container-address-details {
    padding: 0px 0px 0px 16px;
    ${responsive.MOBILE`
      padding: 0 16px 0px 16px;
    `}
  }
`;
